<template>
  <div class="bill-generation">
    <!-- 搜索 -->
    <div class="search">
      <el-form ref="searchForm" :model="searchForm">
        <div class="row">
          <el-form-item label="仓库名称：" prop="warehouseId">
            <el-select class="white" clearable v-model="searchForm.warehouseId" placeholder="请选择仓库">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账单日期：" prop="date">
            <el-date-picker v-model="searchForm.date" type="date" value-format="yyyy-MM-dd" clearable
              placeholder="请选择账单日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn-form">
            <el-button icon="el-icon-search" class="btn-blue" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="btn-container">
        <div class="upload-real" @click="openGenerateRecords">
          <span class="upload-real-img"></span>
          <span>生成记录</span>
        </div>
      </div>
    </div>

    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column v-for="(item, index) in tableTitleList" :key="index" :prop="item.prop" :label="item.label"
          show-overflow-tooltip :min-width="item.width"></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
          @queryChange="queryChange"></pagination-tpl>
      </div>
    </div>

    <!-- 生成记录 -->
    <el-drawer class="bill-generation-drawer" title="生成记录" :visible.sync="billGenerationDrawer" :wrapperClosable="false"
      :before-close="handleCloseBillGenerationDrawer">
      <div class="bill-generation-content">
        <el-form class="bill-generation-form" ref="billGenerationForm" :model="billGenerationForm" :rules="rules">
          <el-form-item label="仓库" prop="warehouseId">
            <el-select class="white" clearable v-model="billGenerationForm.warehouseId" placeholder="请选择仓库"
              popper-class="bill-generation-disabled-select">
              <el-option v-for="item in warehouseByBillGenerationList" :key="item.id" :label="item.name"
                :value="item.id" :disabled="item.billGenerateType == 1">
                <el-tooltip :disabled="item.billGenerateType == 2" effect="light" content="定时生成规则无需手动导入" placement="top"
                  popper-class="bill-generation-tooltip">
                  <span>{{ item.name }}</span>
                </el-tooltip>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker v-model="billGenerationForm.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="下载导入模板">
            <div class="download-tmp" @click="downTmp">
              导入模板.xlsx
              <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
            </div>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
              <template slot="suffix">
                <el-upload v-loading.fullscreen.lock="loading" element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload" ref="upload" action="#" :show-file-list="false" :auto-upload="true"
                  :before-upload="uploadWarehouseLocationExcel">
                  <img class="upload-img" src="~assets/images/home/upload.png">
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img @click="clearUploadFileName" src="~assets/images/close.png">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseBillGenerationDrawer">取消</el-button>
        <el-button class="btn-blue" @click="saveBillRecords('billGenerationForm')">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { downLoadFile } from "common/js/util";
import warehouseMixins from "@/common/mixins/warehouse.js";
import PaginationTpl from "components/base/PaginationTpl";
import BillGeneration from "models/operator/bill-generation";
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  mixins: [warehouseMixins],
  components: {
    PaginationTpl,
  },
  data() {
    return {
      searchForm: {
        warehouseId: "",
        date: ""
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        { label: '仓库名称', prop: 'warehouseName', width: '' },
        { label: '账单日期', prop: 'billDate', width: '' },
        { label: '生成日期', prop: 'executeTime', width: '' },
        { label: '账单生成规则', prop: 'billGenerateType', width: '' },
      ],
      // 账单生成规则状态转译
      billGenerationRulesStatusObj: {
        1: '定时生成',
        2: '补录生成'
      },
      // 根据账单生成规则获取仓库列表
      warehouseByBillGenerationList: [],

      // 生成记录开关
      billGenerationDrawer: false,
      billGenerationForm: {
        warehouseId: null,
        date: null,
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      loading: false,
      uploadFileName: '',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    };
  },
  created() {
    this.initWarehouse();
    this.initBillGenerateRecordsList()
    this.initWarehouseByBillGeneration();
  },
  methods: {
    /** 
     * @description 账单生成记录列表
    */
    initBillGenerateRecordsList() {
      let page = this.currentPage
      let billDate = this.searchForm.date
      let warehouseId = this.searchForm.warehouseId ? this.searchForm.warehouseId:0
      let data = {
        page,
        billDate,
        warehouseId
      }
      BillGeneration.getBillGenerationRecordsList(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.billDate = i.billDate
            obj.executeTime = i.executeTime
            obj.billGenerateType = this.billGenerationRulesStatusObj[i.generateType]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 根据账单生成规则获取仓库列表
    */
    initWarehouseByBillGeneration() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.billGenerateType = i.billGenerateType
            arr.push(obj)
          })
          this.warehouseByBillGenerationList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initBillGenerateRecordsList();
    },

    /**
     * @desc 搜索
     */
    search() {
      this.currentPage = 1;
      this.initBillGenerateRecordsList()
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /** 
     * @desc 开启生成记录
    */
    openGenerateRecords() {
      this.billGenerationDrawer = true
    },

    handleCloseBillGenerationDrawer() {
      this.billGenerationForm.date = null
      this.billGenerationForm.warehouseId = null
      this.$refs['billGenerationForm'].resetFields();
      this.removeUploadOrder()
      this.billGenerationDrawer = false
    },

    removeUploadOrder() {
      this.formData = null
      this.isUpload = true
      this.uploadFileName = ''
    },

    downTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E8%B4%A6%E5%8D%95%E7%94%9F%E6%88%90%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      let fileName = '导入模板'
      downLoadFile(fileName, url)
    },

    //导入Excel表格
    uploadWarehouseLocationExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      this.isUpload = false
      if (file) {
        this.loading = false
      }
      return false;
    },

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      this.isUpload = true
      if (formData.get('file')) {
        formData.delete('file')
      }
    },

    saveBillRecords(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let billDate = this.billGenerationForm.date;
          let warehouseId = this.billGenerationForm.warehouseId;

          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('billDate')) {
            formData.delete('billDate')
          }
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          formData.append("billDate", billDate);
          formData.append("warehouseId", warehouseId);
          BillGeneration.postSaveBillGenerationRecords(formData).then(res => {
            if (res.success) {
              this.initBillGenerateRecordsList();
              this.$message.success("生成成功");
              this.handleCloseBillGenerationDrawer();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/finance/bill-generation.scss';
</style>
